// tagFiltering: タグ選択により記事を絞り込む 表示の実装
//               選択中のタグには「is-active」を付与

export default function tagFiltering() {
  // もっと見るボタンの表示判定
  var default_num = 20;
  var all_num = Number($('.js-archive_list').attr('data-all_num'));
  if (all_num > default_num) {
    $('.js-more_btn').css('display', 'block');
  }
  //カテゴリタブ押下時
  $('.c-genre_item').on('click', function(){
    var term_slug = $(this).attr('data-term_slug') || '';
    var taxo_name = $(this).attr('data-taxo') || '';
    // active判定
    if ($(this).hasClass('is-active')) return;
    $(this).toggleClass('is-active');
    $(this).siblings().removeClass('is-active');

    if (!(term_slug || taxo_name)) return;

    // moreボタンのdata更新
    $('.js-more_btn').attr('data-term_slug', term_slug).attr('data-taxo', taxo_name);

    // postデータ作成
    var template_type = $('main').attr('id');
    var post_data = {
      'term_slug': term_slug,
      'taxo_name': taxo_name,
      'offset': 0,
      'template_type': template_type,
    }
    $.ajax({
      type: "POST",
      url: tmp_path.site_url + "/wp-content/themes/lot/api.php",
      data: post_data,
      dataType: "json",
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        console.log("ajax通信に失敗しました");
      },
      success: function (response) {
        // htmlの追加＋再アニメーション
        $('.js-archive_list').parent('.js-fade-item').removeClass('is-effect');
        $('.js-archive_list').html(response.html);
        setTimeout(function () {
          $('.js-archive_list').parent('.js-fade-item').addClass('is-effect');
        }, 10);

        // 表示数と残り記事数を比較
        if (response.get_num >= Number(response.all_num)) {
          $('.js-more_btn').css('display', 'none');
        } else {
          $('.js-more_btn').css('display', 'block');
        }
      }
    });
  });
  // もっと見る押下時
  $(document).on('click', '.js-more_btn', function (event) {
    event.preventDefault();
    var now_list = $('.js-archive_list li').length;
    var term_slug = $(this).attr('data-term_slug') || '';
    var taxo_name = $(this).attr('data-taxo') || '';
    // postデータ作成
    var template_type = $('main').attr('id');
    var post_data = {
      'term_slug': term_slug,
      'taxo_name': taxo_name,
      'offset': now_list,
      'template_type': template_type,
    }
    $.ajax({
      type: "POST",
      url: tmp_path.site_url + "/wp-content/themes/lot/api.php",
      data: post_data,
      dataType: "json",
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        console.log("ajax通信に失敗しました");
      },
      success: function (response) {
        // htmlの追加＋再アニメーション
        $('.js-archive_list').parent('.js-fade-item').removeClass('is-effect');
        $('.js-archive_list').append(response.html);
        setTimeout(function () {
          $('.js-archive_list').parent('.js-fade-item').addClass('is-effect');
        }, 10);

        // 表示数と残り記事数を比較
        if ((now_list + response.get_num) >= Number(response.all_num)) {
          $('.js-more_btn').css('display', 'none');
        } else {
          $('.js-more_btn').css('display', 'block');
        }
      }
    });
  });
}


// WEBPACK FOOTER //
// ./js/module/tagFiltering.js